export default function HeroSection() {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-teal-900"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/6a0d479d7d84ce4a27e5567c41ce3727.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900/70 via-slate-800/60 to-teal-900/70"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="w-full">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6">
            <span className="sr-only">Brite Solutions - </span>BREAK FREE FROM <span className="text-orange-400">DEBT</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 mb-8 max-w-4xl mx-auto leading-relaxed">
            Professional debt settlement solutions for consumers and businesses since 2008
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <button 
              onClick={() => {
                document.querySelector('#consumer-debt')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 transform hover:scale-105 whitespace-nowrap"
            >
              Get Consumer Relief
            </button>
            <button 
              onClick={() => {
                document.querySelector('#business-debt')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="border-2 border-white text-white hover:bg-white hover:text-slate-900 px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 transform hover:scale-105 whitespace-nowrap"
            >
              Business Debt Solutions
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center">
              <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-calendar-check text-white text-lg"></i>
              </div>
              <h3 className="text-white font-semibold text-lg mb-2">16+ Years Experience</h3>
              <p className="text-gray-300 text-sm">Trusted debt settlement expertise since 2008</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center">
              <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-dollar-sign text-white text-lg"></i>
              </div>
              <h3 className="text-white font-semibold text-lg mb-2">$500M+ Settled</h3>
              <p className="text-gray-300 text-sm">Proven track record of successful settlements</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center">
              <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-star text-white text-lg"></i>
              </div>
              <h3 className="text-white font-semibold text-lg mb-2">A+ BBB Rating</h3>
              <p className="text-gray-300 text-sm">Accredited business with excellent reputation</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
